module.exports = __webpack_public_path__ + "public/media/logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo.png
// module id = ./images/logo.png
// module chunks = 0